export default __webpack_public_path__ + "static/media/abdou.79569a6b.jpg";